import styled from 'styled-components'
import { Col as AntCol, List as AntList } from 'antd'

export const Col = styled(AntCol)`
  text-align: center;
`

export const List = styled(AntList)`
  min-width: 60rem;
` as React.ComponentType as new <T>() => AntList<T>

export const RuleContainer = styled.div`
  margin: 1rem 0;
  overflow-x: scroll;
  overflow: hidden;
  width: 100%;
`
